import {Component, inject, linkedSignal, signal} from '@angular/core';
import {NotificationService, NotificationSummary, NotificationType} from '../../../../../api';
import {NotifService} from '../../../../services/notif.service';
import {lastValueFrom} from 'rxjs';
import {ElciaIcon} from '../../../icon/icon';
import {ElciaDialog} from '../../../dialog/dialog';
import {TranslatePipe} from '@ngx-translate/core';
import {NotificationItem} from '../notification-item/notification-item';
import {BadgeModule} from 'primeng/badge';
import {OverlayBadge} from 'primeng/overlaybadge';
import {Router} from '@angular/router';

@Component({
  selector: 'elcia-bell-notification',
  imports: [
    ElciaIcon,
    ElciaDialog,
    TranslatePipe,
    NotificationItem,
    BadgeModule,
    OverlayBadge,
  ],
  templateUrl: './bell-notification.html',
  styleUrl: './bell-notification.scss',
})
export class BellNotification {
  private readonly notificationService = inject(NotifService);
  private readonly apiNotificationService = inject(NotificationService);
  private readonly router = inject(Router);

  protected notifications = linkedSignal(() => this.notificationService.notifications());
  readonly unreadCount = this.notificationService.unreadCount;
  isDialogDisplayed = signal(false);

  protected async openDialog() {
    this.isDialogDisplayed.set(true);
    await this.markAllAsRead();
    this.notificationService.notifications().forEach(n => n.isRead = true);
    this.notificationService.notifications.update(notifs => [...notifs]);

  }

  protected closeDialog() {
    this.isDialogDisplayed.set(false);
  }

  protected async deleteNotification(notification: NotificationSummary) {
    await lastValueFrom(this.apiNotificationService.deleteNotification(notification.id));
    this.notificationService.notifications.update(notifs => [...notifs.filter(n => n.id !== notification.id)]);
    if (this.notifications()?.length === 0) {
      this.closeDialog();
    }
  }

  protected async markAsRead(notification: NotificationSummary) {
    await lastValueFrom(this.apiNotificationService.markNotificationAsRead(notification.id));
  }

  protected async markAllAsRead() {
    if (this.notifications()?.length) {
      await Promise.all(this.notifications()!.map(async n => await this.markAsRead(n)));

    }
  }

  protected async deleteAllNotifications() {
    if (this.notifications()?.length) {
      await Promise.all(this.notifications()!.map(async n => await this.deleteNotification(n)));
      this.closeDialog();
    }
  }

  protected goToNotification(notificationSummary: NotificationSummary) {
    if (notificationSummary.type === NotificationType.TODOASSIGNEDCHANGED) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/todos'], {queryParams: {highlightTodoId: notificationSummary.objectId}})
      );
      window.open(url, '_blank');
    }
  }
}
